import React from 'react';
import { Link } from 'react-router-dom';
import { IoIosStar } from "react-icons/io";
import { BiPhoneCall } from "react-icons/bi";
import { FiArrowUpRight } from "react-icons/fi";

import bannerImg from '../../assets/images/banner.png';

const HomeBanner = () => {
    return (
        <div className="homeBanner">
            <div className="homeBannerMain">
                <div className="homeBannerMainCol1">
                    <div className="homeBannerThumbnail">
                        <img src={bannerImg} alt="Banner" />
                    </div>
                    <div className="homeBannerTutorDetails">
                        <h2>Vijitha Anish</h2>
                        <p>MSc MSN - Nursing Instructor</p>
                    </div>
                </div>
                <div className="homeBannerMainCol2">
                    <div className="homeRating">
                        <div className="homeRatingStar">
                            <IoIosStar />
                            <IoIosStar />
                            <IoIosStar />
                            <IoIosStar />
                            <IoIosStar />
                        </div>
                        <div className="homeRatingSub">Rated 5/5 from over 500 reviews</div>
                    </div>
                    <h1>Expert Nursing Educator & Exam Prep Partner</h1>
                    <p>Vijitha Anish, an expert nursing instructor, specializes in training nurses for international and national exams like NCLEX RN, DHA, HAAD, and Prometric, ensuring their career success.</p>
                    <div className="homeBannerBtnArea">
                        <Link to="tel:+917736360007" className="homeBannerBtn1"><BiPhoneCall /> Call Now</Link>
                        <Link to="https://athenacoachingcentre.com/demo4/" className="homeBannerBtn2" target="_blank">Athena Coaching Centre <FiArrowUpRight /></Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeBanner;